function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M185.427,0C83.182,0,0,83.182,0,185.426c0,126.888,165.939,313.167,173.004,321.035 c6.636,7.391,18.222,7.378,24.846,0c7.065-7.868,173.004-194.147,173.004-321.035C370.852,83.182,287.671,0,185.427,0z M185.427,469.729C129.58,403.391,33.392,272.512,33.392,185.428c0-83.834,68.202-152.036,152.035-152.036 s152.035,68.202,152.035,152.035C337.461,272.515,241.288,403.37,185.427,469.729z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#47294d",
  d: "M185.427,92.134c-51.442,0-93.292,41.851-93.292,93.293s41.851,93.293,93.292,93.293 s93.291-41.851,93.291-93.293S236.868,92.134,185.427,92.134z M185.427,245.328c-33.03,0-59.9-26.871-59.9-59.901 s26.871-59.901,59.9-59.901s59.9,26.871,59.9,59.901S218.456,245.328,185.427,245.328z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 32,
    viewBox: "0 0 370.854 511.999"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/icon-my-location.8b7c4b93.svg";
export { SvgComponent as ReactComponent };